/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CountByMediaType,
    CountByMediaTypeFromJSON,
    CountByMediaTypeFromJSONTyped,
    CountByMediaTypeToJSON,
} from './CountByMediaType';

/**
 * 
 * @export
 * @interface GetMediaListsResponseAllOfMediaLists
 */
export interface GetMediaListsResponseAllOfMediaLists {
    /**
     * メディアリストのID
     * @type {number}
     * @memberof GetMediaListsResponseAllOfMediaLists
     */
    mediaListId: number;
    /**
     * メディアリストの最終更新日（UNIXTIME）
     * @type {number}
     * @memberof GetMediaListsResponseAllOfMediaLists
     */
    lastEditTime: number;
    /**
     * メディアリスト名
     * @type {string}
     * @memberof GetMediaListsResponseAllOfMediaLists
     */
    mediaListName: string;
    /**
     * メディアリストに含まれる並び順で上位のメディアの名前リスト
     * @type {Array<string>}
     * @memberof GetMediaListsResponseAllOfMediaLists
     */
    topMediaNames: Array<string>;
    /**
     * メディアリストに含まれるメディアのメディア種類ごとのカウント
     * @type {Array<CountByMediaType>}
     * @memberof GetMediaListsResponseAllOfMediaLists
     */
    countByMediaType: Array<CountByMediaType>;
    /**
     * メディアリストに含まれるメディアの総数
     * @type {number}
     * @memberof GetMediaListsResponseAllOfMediaLists
     */
    totalCount: number;
}

export function GetMediaListsResponseAllOfMediaListsFromJSON(json: any): GetMediaListsResponseAllOfMediaLists {
    return GetMediaListsResponseAllOfMediaListsFromJSONTyped(json, false);
}

export function GetMediaListsResponseAllOfMediaListsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMediaListsResponseAllOfMediaLists {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaListId': json['media_list_id'],
        'lastEditTime': json['last_edit_time'],
        'mediaListName': json['media_list_name'],
        'topMediaNames': json['top_media_names'],
        'countByMediaType': ((json['count_by_media_type'] as Array<any>).map(CountByMediaTypeFromJSON)),
        'totalCount': json['total_count'],
    };
}

export function GetMediaListsResponseAllOfMediaListsToJSON(value?: GetMediaListsResponseAllOfMediaLists | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_list_id': value.mediaListId,
        'last_edit_time': value.lastEditTime,
        'media_list_name': value.mediaListName,
        'top_media_names': value.topMediaNames,
        'count_by_media_type': ((value.countByMediaType as Array<any>).map(CountByMediaTypeToJSON)),
        'total_count': value.totalCount,
    };
}

